"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cultureSettingsToCultureContext = cultureSettingsToCultureContext;
var _findCultureSettings = require("../internals/findCultureSettings");
/**
 * Transforms the {@link cultureSettings culture settings} into an object that can be stored in the provider.
 * In case the {@link search} and {@link additionalSearch} parameters contain no value or no culture settings found, the default culture code will be searched.
 * Financial settings is always searched for the default financial set.
 * @param cultureSettings The culture settings
 * @param search The value to be first searched for in the {@link cultureSettings culture settings}
 * @param additionalSearch The additional value to be second searched for in the {@link cultureSettings culture settings}
 * @returns An object containing selected culture settings
 */
function cultureSettingsToCultureContext(cultureSettings, search, additionalSearch) {
  const {
    cultures,
    defaultCultureCode,
    financialSets,
    defaultFinancialSetId,
    timeZone
  } = cultureSettings ?? {};
  const culture = (0, _findCultureSettings.findCultureSettings)(cultures, search) ?? (0, _findCultureSettings.findCultureSettings)(cultures, additionalSearch) ?? (0, _findCultureSettings.findCultureSettings)(cultures, defaultCultureCode) ?? cultures?.[0];
  const {
    cultureCode: language
  } = culture ?? {};
  if (cultureSettings && !culture) {
    throw new Error('No Culture found!');
  }
  const financialSet = financialSets?.find(({
    financialSetId
  }) => financialSetId === defaultFinancialSetId) ?? financialSets?.[0];
  if (cultureSettings && !financialSet) {
    throw new Error('No FinancialSet found!');
  }
  return {
    language,
    culture,
    financialSet,
    timeZone
  };
}
//# sourceMappingURL=cultureSettingsToCultureContext.js.map